module.exports = __webpack_public_path__ + "static/img/img-home-faster_gxtj.6c7f740b.jpg";